import React, { useEffect, useRef, useState } from 'react';
import { useAuth } from '../AuthContext';

export default function ChatbotWidget() {
  // Build-time flag. Keep existing deployments visible unless explicitly disabled.
  if (process.env.REACT_APP_CHATBOT_ENABLED?.trim().toLowerCase() === 'false') return null;
  return <EnabledChatbotWidget />;
}

function EnabledChatbotWidget() {
  const { apiUrl } = useAuth();
  const [open, setOpen] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const frame = useRef(null);
  const launcher = useRef(null);
  const source = process.env.REACT_APP_CHATBOT_URL || '/chatbot/index.html';
  const initialize = () => {
    const origin = new URL(source, window.location.origin).origin;
    frame.current?.contentWindow?.postMessage({type:'stunm-chatbot:init', apiUrl:apiUrl || window.location.origin}, origin);
  };
  useEffect(() => {
    const listener = event => {
      if (event.source === frame.current?.contentWindow && event.origin === new URL(source, window.location.origin).origin && event.data?.type === 'stunm-chatbot:workspace-changed') {
        window.dispatchEvent(new Event('stunm:workspace-changed'));
      }
      if (event.source === frame.current?.contentWindow && event.origin === new URL(source, window.location.origin).origin && event.data?.type === 'stunm-chatbot:ready') {
        event.source.postMessage({type:'stunm-chatbot:init', apiUrl:apiUrl || window.location.origin}, event.origin);
      }
    };
    window.addEventListener('message', listener);
    return () => window.removeEventListener('message', listener);
  }, [source, apiUrl]);
  const close = () => {setOpen(false); launcher.current?.focus();};
  return <div style={{position:'fixed',right:16,bottom:16,zIndex:1000}}>
    {loaded && <section hidden={!open} aria-label="StunM chatbot" style={{width:'min(420px, calc(100vw - 32px))',height:'min(720px, calc(100dvh - 100px))',background:'white',borderRadius:8,overflow:'hidden',boxShadow:'0 12px 55px #0f172a33',marginBottom:10}}>
      <div style={{display:'flex',justifyContent:'flex-end',background:'#2a3999'}}><button aria-label="Close assistant" className="rounded-md hover:bg-white/10 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white" onClick={close} style={{color:'white',padding:'6px 14px'}}>Close ×</button></div>
      <iframe ref={frame} title="StunM Assistant" src={source} onLoad={initialize} sandbox="allow-scripts allow-same-origin allow-forms" referrerPolicy="strict-origin" style={{width:'100%',height:'calc(100% - 36px)',border:0}} />
    </section>}
    <button ref={launcher} aria-expanded={open} onClick={()=>{if(open) close(); else {setLoaded(true);setOpen(true);}}} className="float-right flex items-center gap-2 rounded-md bg-darkPurple px-4 py-2 text-white hover:opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-darkPurple">Ask StunM</button>
  </div>;
}
